import { SVGProps } from "react";

export function WarningIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width="1em"
      height="1em"
      {...props}
    >
      <g fill="none">
        <path
          fill="url(#fluentColorWarning160)"
          d="M9.092 2.638a1.25 1.25 0 0 0-2.182 0L2.157 11.14A1.25 1.25 0 0 0 3.247 13h9.504a1.25 1.25 0 0 0 1.091-1.86z"
        ></path>
        <path
          fill="url(#fluentColorWarning161)"
          d="M8.75 10.25a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0M7.5 8V5.5a.5.5 0 0 1 1 0V8a.5.5 0 0 1-1 0"
        ></path>
        <defs>
          <linearGradient
            id="fluentColorWarning160"
            x1="3.872"
            x2="10.725"
            y1=".279"
            y2="14.525"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFCD0F"></stop>
            <stop offset="1" stopColor="#FE8401"></stop>
          </linearGradient>
          <linearGradient
            id="fluentColorWarning161"
            x1="6"
            x2="8.466"
            y1="5"
            y2="11.575"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#4A4A4A"></stop>
            <stop offset="1" stopColor="#212121"></stop>
          </linearGradient>
        </defs>
      </g>
    </svg>
  );
}
